var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResturant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 502 502",
    style: {
      enableBackground: "new 0 0 502 502"
    },
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FBB03B"
    },
    points: "323.149,209.413 359.224,209.413 359.224,10 323.149,41.064    "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FBB03B"
    },
    points: "323.149,245.488 287.075,245.488 287.075,46.074 323.149,77.139    "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FBB03B"
    },
    points: "251,250.499 287.075,250.499 287.075,16.012 251,47.076    "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FBB03B"
    },
    points: "251,251.501 214.925,251.501 214.925,52.087 251,83.151    "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FBB03B"
    },
    points: "178.85,247.492 214.925,247.492 214.925,13.006 178.85,44.07    "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FBB03B"
    },
    points: "178.85,248.494 142.775,248.494 142.775,49.081 178.85,80.145    "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FBB03B"
    },
    points: "106.7,212.42 70.626,212.42 70.626,92.17 106.7,118.608   "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FBB03B"
    },
    points: "106.7,222.44 142.775,222.44 142.775,81.147 106.7,112.212   "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FBB03B"
    },
    points: "178.85,243.484 142.775,243.484 142.775,102.191 178.85,133.255   "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FBB03B"
    },
    points: "178.85,279.559 214.925,279.559 214.925,138.266 178.85,169.33   "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FBB03B"
    },
    points: "251,284.569 214.925,284.569 214.925,108.203 251,139.268   "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FBB03B"
    },
    points: "251,285.571 287.075,285.571 287.075,144.278 251,175.343   "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FBB03B"
    },
    points: "323.149,281.563 287.075,281.563 287.075,105.197 323.149,136.262   "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FBB03B"
    },
    points: "323.149,282.565 359.224,282.565 359.224,141.272 323.149,172.336   "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FBB03B"
    },
    points: "395.299,251.501 359.224,251.501 359.224,75.135 395.299,106.199   "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FBB03B"
    },
    points: "395.299,252.503 431.374,252.503 431.374,111.21 395.299,142.274   "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C1272D"
    },
    d: "M379.71,160.311c-1.82,56.676-58.748,102.166-128.71,102.166s-126.89-45.489-128.71-102.166H48.768    L110.347,492h281.305l61.579-331.688H379.71z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FBB03B"
    },
    cx: 251,
    cy: 375.758,
    rx: 82.17,
    ry: 54.112
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M460.921,153.919c-1.9-2.285-4.718-3.607-7.689-3.607h-11.857V111.21c0-3.909-2.278-7.46-5.832-9.09    c-3.552-1.628-7.73-1.039-10.693,1.512l-19.55,16.834v-14.267c0-2.911-1.269-5.678-3.475-7.578l-32.6-28.072V10    c0-3.909-2.278-7.46-5.832-9.09c-3.552-1.628-7.73-1.039-10.693,1.512l-36.075,31.064c-2.206,1.899-3.475,4.667-3.475,7.578    v14.267l-16.074-13.842V16.012c0-3.91-2.278-7.46-5.832-9.09c-3.552-1.629-7.73-1.039-10.693,1.512l-36.075,31.064    c-2.206,1.899-3.475,4.667-3.475,7.578v14.267l-16.075-13.843V13.006c0-3.91-2.278-7.46-5.832-9.09    c-3.551-1.628-7.731-1.039-10.693,1.512l-36.074,31.064c-2.206,1.9-3.475,4.667-3.475,7.578v14.267l-19.55-16.834    c-2.963-2.551-7.141-3.142-10.693-1.512c-3.554,1.629-5.832,5.18-5.832,9.09v27.481l-30.588,26.34l-25.65-18.798    c-3.039-2.227-7.072-2.556-10.433-0.854c-3.36,1.704-5.479,5.152-5.479,8.919v58.142H48.768c-2.972,0-5.789,1.322-7.689,3.607    c-1.899,2.285-2.685,5.296-2.143,8.218l61.579,331.688c0.88,4.738,5.013,8.175,9.832,8.175h281.305    c4.819,0,8.952-3.437,9.832-8.175l61.579-331.688C463.605,159.215,462.82,156.204,460.921,153.919z M421.374,133.017v17.294    h-16.075v-3.452L421.374,133.017z M369.224,96.943l16.074,13.842v31.489v8.038h-5.588c-5.397,0-9.821,4.284-9.995,9.679    c-0.07,2.183-0.237,4.354-0.491,6.511V96.943z M168.85,226.013c-0.514-0.394-1.028-0.788-1.534-1.191    c-5.442-4.329-10.301-9.011-14.541-13.982v-86.841l16.075,13.842V226.013z M204.925,245.059    c-5.55-1.874-10.921-4.091-16.074-6.637v-64.506l16.074-13.842V245.059z M241,252.139c-5.441-0.362-10.811-1.013-16.075-1.955    V130.011L241,143.853V252.139z M277.075,250.184c-5.265,0.942-10.634,1.593-16.075,1.955v-72.211l16.075-13.842V250.184z     M313.149,238.422c-5.153,2.546-10.524,4.763-16.074,6.637V127.005l16.074,13.842V238.422z M349.224,210.84    c-4.24,4.97-9.099,9.653-14.541,13.982c-0.506,0.403-1.021,0.797-1.534,1.191v-49.091l16.075-13.842V210.84z M349.224,136.686    l-16.075,13.843V45.649l16.075-13.842V136.686z M313.149,81.724v32.729l-16.074-13.842V67.882L313.149,81.724z M277.075,139.692    L261,153.535V51.662l16.075-13.842V139.692z M241,87.737v29.723l-16.075-13.843V73.895L241,87.737z M204.925,133.68    l-16.074,13.842V48.656l16.074-13.842V133.68z M152.775,70.888l16.075,13.842v26.717l-16.075-13.843V70.888z M116.701,116.797    l16.074-13.842v63.547c-0.254-2.157-0.421-4.328-0.491-6.511c-0.174-5.396-4.598-9.679-9.995-9.679h-5.588v0V116.797z     M80.626,111.897l16.075,11.781v26.634H80.626V111.897z M383.338,482H118.662L60.796,170.312h52.293    c3.544,26.727,18.131,51.354,41.777,70.163c25.947,20.637,60.088,32.003,96.134,32.003s70.187-11.366,96.134-32.003    c23.646-18.808,38.233-43.436,41.777-70.163h52.293L383.338,482z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.603,329.144C297.47,317.86,274.881,311.646,251,311.646s-46.47,6.214-63.604,17.498    c-18.422,12.131-28.567,28.686-28.567,46.615s10.146,34.483,28.567,46.615c17.134,11.284,39.723,17.498,63.604,17.498    s46.47-6.214,63.604-17.498c18.422-12.131,28.567-28.686,28.567-46.615S333.025,341.275,314.603,329.144z M251,419.871    c-39.121,0-72.171-20.201-72.171-44.112s33.05-44.112,72.171-44.112s72.171,20.201,72.171,44.112S290.121,419.871,251,419.871z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.058,365.758H250c-5.522,0-10,4.477-10,10s4.478,10,10,10h39.059c5.522,0,10-4.477,10-10    S294.581,365.758,289.058,365.758z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219,365.758h-6.059c-5.522,0-10,4.477-10,10s4.478,10,10,10H219c5.522,0,10-4.477,10-10S224.522,365.758,219,365.758z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResturant);
export default __webpack_public_path__ + "static/media/Resturant.eeef1f26f2fe3e4b65dfb666fb3c50f9.svg";
export { ForwardRef as ReactComponent };